/**
 * 編譯期設定。
 *
 * C03 §5 / CONSTRAINTS #15：每個站點各自獨立的 client、儲存前綴、PUBLIC_BASE_URL；
 * `redirect_uri` **絕不**從 `window.location.host` 組出來。
 */

export type Locale = 'zh-TW' | 'en';

function env(key: string, fallback: string): string {
  const raw = (import.meta.env as Record<string, string | undefined>)[key];
  return raw === undefined || raw === '' ? fallback : raw;
}

export const config = {
  apiBaseUrl: env('VITE_API_BASE_URL', 'https://api.gaming.enlightenmentlab.dev/api/v1'),
  publicBaseUrl: env('VITE_PUBLIC_BASE_URL', 'https://gaming.enlightenmentlab.dev').replace(/\/+$/, ''),
  basePath: env('VITE_PUBLIC_BASE_PATH', '/'),
  oidcIssuer: env('VITE_OIDC_ISSUER', ''),
  oidcClientId: env('VITE_OIDC_CLIENT_ID', 'gaming-portal-web'),
  rpsLobbyUrl: env('VITE_RPS_LOBBY_URL', 'https://rps.gaming.enlightenmentlab.dev'),
  useMocks: env('VITE_USE_MOCKS', '0') === '1',
  defaultLocale: (env('VITE_DEFAULT_LOCALE', 'zh-TW') === 'en' ? 'en' : 'zh-TW') as Locale,
  buildVersion: env('VITE_BUILD_VERSION', 'dev'),
  /** C03 §5：每站獨立的儲存前綴，兄弟子網域不共用 session。 */
  storagePrefix: 'elabgaming.portal.',
};

/** 登入是選配的：沒有設定 issuer 就整個關掉入口，站台照常運作。 */
export const loginEnabled = config.oidcIssuer.length > 0;

/** 一律用編譯期的 publicBaseUrl 組絕對網址。 */
export function absoluteUrl(path: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const base = config.basePath === '/' ? '' : config.basePath.replace(/\/+$/, '');
  return `${config.publicBaseUrl}${base}${normalized}`;
}
